<div class="add-custom-value mat-elevation-z4">
    <p>All the entries will be concatenate to one custom value</p>
    <div class="add-custom-value-buttons">
        <button mat-icon-button color="primary" class="add-value" title="Add Value"
                (click)="addCustomConditionValue()">
            <mat-icon class="icons-inner">add</mat-icon>
        </button>
    </div>
    <div class="add-custom-value-container">
        <div class="add-custom-value-container-item"
             *ngFor="let customConditionValue of customConditionValues; let index = index; trackBy: trackByIdx">
            <mat-form-field class="custom-value">
                <mat-label>Value</mat-label>
                <input matInput (ngModelChange)="updateSubjectSuggestions($event)"
                       placeholder="Select header or insert free text"
                       [ngModelOptions]="{standalone: true}" required
                       (focusin)="updateSubjectSuggestions(customConditionValues[index])"
                       [(ngModel)]="customConditionValues[index]" [matAutocomplete]="auto">
                <mat-autocomplete #auto="matAutocomplete">
                    <mat-option *ngFor="let option of subjectSuggestions" [value]="option">
                        <span [innerHTML]="option | highlight: customConditionValues[index]"></span>
                    </mat-option>
                </mat-autocomplete>
                <mat-error>
                    Value is <strong>required</strong>
                </mat-error>
            </mat-form-field>
            <div class="remove-item">
                <i class="fa fa-times" [ngClass]="{'fa-disabled': customConditionValues.length === 1}"
                   (click)="removeCustomConditionValue(index)"></i>
            </div>
        </div>
    </div>
    <p class="custom-value-display">
        {{generateCustomValue()}}
    </p>
    <div class="dual-list-buttons">
        <ac-button class="apply-button"
                   [ngDisabled]="isValidCustomValue()"
                   (acClick)="onAddValueApply()"
                   [buttonValue]="'Apply'">
        </ac-button>

        <ac-button (acClick)="onAddValueCancel()"
                   [buttonValue]="'Cancel'">
        </ac-button>
    </div>
</div>
